import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import LoginForm from './LoginForm';

interface ProtectedRouteProps {
  children: React.ReactNode;
  roles?: string[];
  fallback?: React.ReactElement;
}

const ProtectedRoute = ({
  children,
  roles = [],
  fallback
}: ProtectedRouteProps): React.ReactElement => {
  const { user, loading, isAuthenticated, hasRole } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-indigo-500"></div>
      </div>
    );
  }

  // Если пользователь не авторизован, показываем форму входа
  if (!isAuthenticated) {
    return fallback ? fallback : <LoginForm />;
  }

  // Если указаны роли и пользователь не имеет нужной роли
  if (roles.length > 0 && !hasRole(roles)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="max-w-md w-full">
          <div className="bg-white shadow-lg rounded-lg p-6 text-center">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
              <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.5 0L3.732 16c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">
              Доступ запрещен
            </h3>
            <p className="text-sm text-gray-600 mb-4">
              У вас недостаточно прав для доступа к этой странице.
            </p>
            <p className="text-xs text-gray-500">
              Ваша роль: <span className="font-medium">{user?.role}</span>
              <br />
              Требуется: <span className="font-medium">{roles.join(', ')}</span>
            </p>
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</> as React.ReactElement;
};

export default ProtectedRoute;